export const RESULT_MAPPING_KEY = 'perspective.result-mapping.';
export const TRACKING_KEY = 'perspective.tracking-preferences.';
export const TRACKING_PROPERTIES_KEY = 'perspective.tracking-properties.';
export const SPLIT_TESTING_KEY = 'perspective.split-testing-variant.';
export const USER_ID_KEY = 'perspective__user__id';
export const COLOR_LIGHT = '#F5F5F5';
export const COLOR_DARK = '#2A2A2A';
export const TRANSITION_DELAY = 150;
